module.exports = __webpack_public_path__ + "img/foodtype-chinese.87713fed.png";